<template>
  <form
    @submit.prevent.stop=""
    v-if="c && !loading"
    :key="viewId + c.pk">
    <tabs
      :level="1"
      :is-fullwidth="true"
      :links="contactFormTabsLinks"
      :current-tab="contactFormTab"
      @changeView="handleTabChange"
      mode="emitter"
      class="is-border-bottom"></tabs>
    <div v-show="contactFormTab === 'FICHE_CONTACT'">
      <div>
        <div class="has-background-dark is-padding-left is-padding-right">
          <div class="has-text-white is-size-6 is-padding-top-xxsmall is-padding-bottom-xxsmall">
            <span class="icon is-small is-size-7 is-margin-right-xxsmall">
              <i class="fas fa-check-circle"></i></span>
            <i>Information obligatoire pour la validation du formulaire</i>
          </div>
        </div>
        <alert-doublon
          :doublonfromquickview="paramsQuickview"
          :doublonfromcontacform="checkDoublon"
          :doublonfromcalendar="alertdoubloncheck"
          :contact="c">
        </alert-doublon>
      </div>
      <div
        v-if="((isAdmin || isManager || isOperator) && !!plan && plan.can_add_users)"
        class="is-padding has-background-white--darken1">
        <div class="columns is-multiline">
          <div
            class="column is-6"
            v-if="(isAdmin || isManager || isOperator) && !!plan && plan.can_add_users && !fromQuickview">
            <div class="field">
              <r-label
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Utilisateur Référent'"
                :value="contactUser"></r-label>
              <div
                class="control"
                v-if="users">
                <multiselect
                  id="referent-user"
                  class="multiselect--option-ico"
                  name="referent-user"
                  v-model="contactUser"
                  :options="users"
                  :multiple="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="''"
                  :custom-label="v => `${v.last_name + ' ' + v.first_name}`"
                  track-by="pk"
                  @search-change="getSellers">
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Sélectionnez un utilisateur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div
            class="column"
            :class="!fromQuickview ? 'is-6' : ''">
            <div class="field">
              <r-label
                :is-required="false"
                :label="'Origine du contact'"
                :value="contactOrigin"></r-label>
              <div
                class="control"
                v-if="origins">
                <multiselect
                  id="origin-contact"
                  class="multiselect--option-ico"
                  name="origin-contact"
                  group-values="children"
                  group-label="name"
                  v-model="contactOrigin"
                  :options="activeOriginGroups"
                  :multiple="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="''"
                  :custom-label="originName"
                  track-by="pk"
                  @search-change="getOrigins">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="origins.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Sélectionnez une origine</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div
            v-if="canEditProgram"
            class="column"
            :class="'is-6'">
            <div class="field">
              <r-label
                :is-required="false"
                :label="'Programme d\'origine'"
                :value="c.original_program"></r-label>
              <div
                class="control">
                <multiselect
                  @input="c.original_program = $event"
                  @search-change="getProgramsByName"
                  @open="!programsFilter.length ? getProgramsByName() : null"
                  v-model="c.original_program"
                  label="name"
                  track-by="pk"
                  :disabled="false"
                  :options="programsFilter"
                  :multiple="false"
                  :taggable="true"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programme</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Programmes ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div
            v-if="canEditProgram"
            class="column"
            :class="'is-6'">
            <div class="field">
              <r-label
                :is-required="false"
                :label="'Programme associé'"
                :value="c.programs"></r-label>
              <div
                class="control">
                <multiselect
                  @input="c.programs = $event"
                  @search-change="getProgramsByName"
                  @open="!programsFilter.length ? getProgramsByName() : null"
                  v-model="c.programs"
                  label="name"
                  track-by="pk"
                  :disabled="false"
                  :options="programsFilter"
                  :multiple="true"
                  :taggable="true"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :placeholder="''">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="programs.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programme</span>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="is-padding has-background-light is-border-bottom" v-if="!fromQuickview"> -->
      <div class="is-padding has-background-light is-border-bottom">
        <div class="field">
          <r-label
            :is-required="hasCheck"
            :red-check="hasCheck"
            :label="'Nature du contact'"
            :value="c.nature"></r-label>
          <div class="control">
            <div class="columns is-variable is-2 is-multiline is-vcentered">
              <div class="column is-half">
                <input
                  id="nature_human"
                  type="radio"
                  name="nature"
                  value="human"
                  v-model="c.nature"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  :class="{'is-active' : c.nature === 'human'}">
                <label
                  id="nature_human"
                  for="nature_human">Personne physique</label>
              </div>
              <div class="column is-half">
                <input
                  id="nature_corporation"
                  type="radio"
                  name="nature"
                  value="corporation"
                  v-model="c.nature"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  :class="{'is-active' : c.nature === 'corporation'}">
                <label
                  id="nature_corporation"
                  for="nature_corporation">Personne morale</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="is-padding has-background-light is-border-bottom"
        v-if="!isHuman && isCorporation">
        <div class="columns is-multiline">
          <div class="column is-6">
            <v-input
              id="corporation_name"
              name="corporation_name"
              @input="c.corporation_name = $event"
              :model="c.corporation_name"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Nom société">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Nom société'"
                :value="c.corporation_name"></r-label>
            </v-input>
          </div>
          <div class="column is-6">
            <v-input
              id="corporation_siret"
              name="corporation_siret"
              @input="c.corporation_siret = $event"
              :model="c.corporation_siret"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="SIRET Société">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Siret société'"
                :value="c.corporation_siret"></r-label>
            </v-input>
          </div>
        </div>
      </div>
      <div class="is-padding has-background-light">
        <div class="field">
          <r-label
            :is-required="hasCheck || claimCreateContact"
            :red-check="hasCheck"
            :label="'Civilité'"
            :value="c.title"></r-label>
          <div class="control">
            <div class="columns is-variable is-2 is-multiline is-vcentered">
              <div class="column is-4">
                <input
                  :id="'title-m' + viewId"
                  :name="'title-m' + viewId"
                  type="radio"
                  value="m"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  v-model="c.title">
                <label :for="'title-m' + viewId">
                  <span class="icon is-size-4 "><i class="fas fa-male"></i></span>M.
                </label>
              </div>
              <div class="column is-4">
                <input
                  :name="'title-mme' + viewId"
                  :id="'title-mme' + viewId"
                  type="radio"
                  value="mme"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  v-model="c.title">
                <label :for="'title-mme' + viewId">
                  <span class="icon is-size-4 "><i class="fas fa-female"></i></span>Mme
                </label>
              </div>
            </div>
          </div>
          <p
            v-if="errors.has('title')"
            class="column is-12">
            La civilité est obligatoire.
          </p>
        </div>
        <div class="columns is-multiline">
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="last_name"
              name="last_name"
              @input="c.last_name = $event.trim()"
              :model="c.last_name"
              :errors-bag="errors"
              v-validate="'required|min:2'"
              data-vv-value-path="val"
              data-vv-as="Nom">
              <r-label
                slot="label"
                :red-check="hasCheck"
                :label="'Nom'"
                :value="c.last_name"></r-label>
            </v-input>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="first_name"
              name="first_name"
              @input="c.first_name = $event.trim()"
              :model="c.first_name"
              :errors-bag="errors"
              v-validate="'required|min:2'"
              data-vv-value-path="val"
              data-vv-as="Prénom">
              <r-label
                slot="label"
                :red-check="hasCheck"
                :label="'Prénom'"
                :value="c.first_name"></r-label>
            </v-input>
          </div>
          <div
            class="column is-6"
            v-if="!fromQuickview">
            <v-input
              id="birth_name"
              name="birth_name"
              @input="c.birth_name = $event"
              :model="c.birth_name"
              :errors-bag="errors"
              v-validate="'min:2'"
              data-vv-value-path="val"
              data-vv-as="Nom de naissance">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Nom de naissance'"
                :value="c.birth_name"></r-label>
            </v-input>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="email"
              name="email"
              @input="c.email = $event"
              :model="c.email"
              :errors-bag="errors"
              :input-type="'email'"
              v-validate="'email'"
              data-vv-value-path="val"
              data-vv-as="Adresse email"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="hasCheck || claimCreateContact"
                :red-check="hasCheck"
                :label="'Adresse email'"
                :value="c.email"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-paper-plane"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="phone"
              name="phone"
              @input="c.phone = $event"
              :model="c.phone"
              :errors-bag="errors"
              :input-type="'tel'"
              :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
              v-validate="'min:10'"
              data-vv-value-path="val"
              data-vv-as="Téléphone"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="hasCheck || claimCreateContact"
                :red-check="hasCheck"
                :label="'Téléphone (fixe ou mobile)'"
                :value="c.phone"
                :truncate="false">
                <span
                  class="is-padding-left-xsmall"
                  v-helper.top="'6BNfgrh0uP7V5UyMRsZvQp'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-phone-office"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div
            v-if="c.account && c.account.external_connection && c.account.external_connection.length || currentUser.account.external_connection && currentUser.account.external_connection.length"
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="externalId"
              name="externalId"
              @input="c.external_id = $event"
              :model="c.external_id"
              :errors-bag="errors"
              :input-type="'string'"
              data-vv-value-path="val"
              data-vv-as="ID Externe"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="hasCheck || claimCreateContact"
                :red-check="hasCheck"
                :label="'ID Externe'"
                :value="c.externalId"
                :truncate="false">
              </r-label>
            </v-input>
          </div>
          <div class="column is-12">
            <address-input
              :source="c.address"
              :model="c.address"
              :from-quickview="fromQuickview"
              :params-quickview="paramsQuickview"
              :is-required="hasCheck"
              :red-check="hasCheck"
              :has-addons="true"
              @listendatatoredirect="ListenDataToRedirect"
              @update="updateAddress">
            </address-input>
          </div>
          <!-- <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-6'">
            <v-input
              id="additionnal_address"
              name="additionnal_address"
              @input="c.adress.additionnal_address = $event"
              :model="c.address.additionnal_address"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Complément d'adresse"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="hasCheck || claimCreateContact"
                :red-check="hasCheck"
                :label="'Complément d\'adresse'"
                :value="c.address.additionnal_address"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-paper-plane"></i></span>
                </a>
              </p>
            </v-input>
          </div> -->
        </div>
      </div>
      <div
        class="has-background-black "
        style="position: sticky; bottom: 0px; z-index: 4"
        v-if="fromQuickview && !isReplaceBuyer">
        <a
          @click="showMoreQuickview = !showMoreQuickview"
          v-scroll-to="{el: `#company-${viewId}`, container: '.quickview-body'}"
          class="column is-padding-bottom-small is-padding-top-small is-padding-left-large is-padding-right-large has-text-white is-uppercase is-size-6">
          Informations complémentaires
          <span class="icon is-pulled-right"><i
            class="far"
            :class="showMoreQuickview ? 'fa-angle-up' : 'fa-angle-down'"></i></span>
        </a>
      </div>
      <div
        class="is-padding has-background-light"
        v-if="!fromQuickview || showMoreQuickview || isReplaceBuyer">
        <div class="columns is-multiline">
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="!fromQuickview || showMoreQuickview || isReplaceBuyer">
            <date-picker
              :model="c.birthday"
              :style-version="2"
              @input="c.birthday = $event"
              label="Date de naissance"
              :is-required="hasCheck"
              :red-check="hasCheck"></date-picker>
            <label class="label"></label>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="!fromQuickview || showMoreQuickview || isReplaceBuyer">
            <v-input
              id="birthplace"
              name="birthplace"
              @input="c.birthplace = $event"
              :model="c.birthplace"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Lieu de naissance"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Lieu de naissance'"
                :value="c.birthplace"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="!fromQuickview || showMoreQuickview || isReplaceBuyer">
            <v-input
              id="nationality"
              name="nationality"
              @input="c.nationality = $event"
              :model="c.nationality"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Nationalité">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Nationalité'"
                :value="c.nationality"></r-label>
            </v-input>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="!fromQuickview || isReplaceBuyer">
            <r-label
              :is-required="hasCheck"
              :red-check="hasCheck"
              label="Situation Familiale"
              :value="c.family_situation"></r-label>
            <div class="select is-fullwidth">
              <select v-model="c.family_situation">
                <option :value="null">
                  Selectionnez
                </option>
                <option
                  v-for="s in familySituationList"
                  :value="s.value"
                  :key="s.value">
                  {{ s.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="!fromQuickview || isReplaceBuyer">
            <r-label
              :is-required="isMarriedOrPacsed"
              :red-check="hasCheck"
              :label="c.family_situation === 'pacs' ? 'Régime de PACS' : 'Statut Matrimonial'"
              :value="c.matrimonial_status"></r-label>
            <div class="select is-fullwidth">
              <select
                v-model="c.matrimonial_status"
                :disabled="!['married', 'pacs'].includes(c.family_situation) || c.family_situation === null">
                <option :value="null">
                  Selectionnez
                </option>
                <option
                  v-for="s in matrimonalStatusList"
                  :value="s.value"
                  :key="s.value">
                  {{ s.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="column is-4"
            v-if="!fromQuickview">
            <r-label
              slot="label"
              :is-required="false"
              label="Nombre d'enfant"
              :value="c.children"></r-label>
            <div class="select is-fullwidth">
              <select v-model="c.children">
                <option :value="null">
                  Selectionnez
                </option>
                <option
                  v-for="i in 11"
                  :key="i"
                  :value="i - 1">
                  {{ i - 1 }}
                </option>
              </select>
            </div>
          </div>
          <div
            v-for="(child, i) in childrenNumber"
            :key="i"
            class="column is-4">
            <div>
              <date-picker
                :model="c.children_date[i]"
                :style-version="2"
                @input="c.children_date[i] = $event"
                :label="`Date de naissance enfant ${i + 1}`"
                :is-required="false"></date-picker>
              <label class="label"></label>
            </div>
          </div>
          <div
            class="column is-4"
            v-if="!fromQuickview && ['divorced'].includes(c.family_situation)">
            <date-picker
              :model="c.divorce_date"
              :style-version="2"
              @input="c.divorce_date = $event"
              :is-required="false"
              :label="c.family_situation === 'divorced' ? 'Date de divorce' : null"></date-picker>
            <label class="label"></label>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="(!fromQuickview || isReplaceBuyer) && ['married', 'pacs'].includes(c.family_situation)">
            <date-picker
              :model="c.wedding_date"
              :style-version="2"
              @input="c.wedding_date = $event"
              :is-required="hasCheck"
              :red-check="hasCheck"
              :label="c.family_situation === 'married' ? 'Date du mariage' : 'Date du PACS'"></date-picker>
            <label class="label"></label>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'"
            v-if="(!fromQuickview || isReplaceBuyer) && ['married', 'pacs'].includes(c.family_situation)">
            <v-input
              id="wedding_place"
              name="wedding_place"
              @input="c.wedding_place = $event"
              :model="c.wedding_place"
              :errors-bag="errors"
              data-vv-value-path="val"
              :data-vv-as="c.family_situation === 'married' ? 'Lieu du mariage' : 'Lieu du PACS'"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="isMarriedOrPacsed"
                :red-check="hasCheck"
                :label="c.family_situation === 'married' ? 'Lieu du mariage' : 'Lieu du PACS'"
                :value="c.wedding_place"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div
            class="column is-4"
            v-if="!fromQuickview && ['married'].includes(c.family_situation)">
            <v-input
              id="wedding_notary_name"
              name="wedding_notary_name"
              @input="c.wedding_notary_data.name = $event"
              :model="c.wedding_notary_data.name"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Nom du notaire du mariage">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Nom du notaire du mariage'"
                :value="c.wedding_notary_data.name"></r-label>
            </v-input>
          </div>
          <div
            class="column is-4"
            v-if="!fromQuickview && ['married'].includes(c.family_situation)">
            <v-input
              id="wedding_notary_city"
              name="wedding_notary_city"
              @input="c.wedding_notary_data.city = $event"
              :model="c.wedding_notary_data.city"
              :errors-bag="errors"
              data-vv-value-path="val"
              :data-vv-as="'Commune du notaire du mariage'"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Commune du notaire du mariage'"
                :value="c.wedding_notary_data.city"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="columns is-multiline is-padding"
          v-if="contactSpouse && !fromQuickview">
          <r-label
            class="column is-12 is-paddingless-left"
            label="Conjoint(e)"
            :is-required="false"></r-label>
          <div class="column columns is-6 is-border has-background-white">
            <div class="column is-9 is-vcentered columns is-marginless-bottom">
              <avatar :item="contactSpouse"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4">
                  <b>{{ contactSpouse.last_name }} {{ contactSpouse.first_name }}</b><br>
                  <a
                    @click="openSpouseEdit(contactSpouse)"
                    class="is-underline is-size-6 is-italic">Modifier fiche</a>
                </div>
              </div>
            </div>
            <div class="column is-3 has-text-right actions">
              <a
                @click="contactSpouse = null"
                class="button is-circle"><i class="fal fa-times"></i></a>
            </div>
          </div>
        </div>
        <div
          class="columns"
          v-else-if="!fromQuickview && !contactSpouse && !newContact">
          <div class="column is-narrow">
            <a
              class="button is-rounded is-padding-right-large is-padding-left-large"
              @click="createSpouseContact">
              <span class="icon is-medium"><i class="is-size-4 fas fa-user-crown"></i></span>
              <span>Créer fiche conjoint(e)</span>
            </a>
          </div>
          <div class="column is-narrow">
            <a
              class="button is-rounded is-padding-right-large is-padding-left-large"
              @click="openContactSelection('simple')">
              <span class="icon is-medium"><i class="is-size-4 fas fa-users-crown"></i></span>
              <span>Sélectionner fiche conjoint(e)</span>
            </a>
          </div>
        </div>
        <div class="columns is-multiline">
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'">
            <r-label
              :is-required="false"
              label="CSP"
              :value="c.csp"></r-label>
            <div class="select is-fullwidth">
              <select v-model="c.csp">
                <option :value="null">
                  Selectionnez le CSP
                </option>
                <option
                  v-for="contactCsp in contactCspList"
                  :value="contactCsp.csp || contactCsp.value"
                  :key="contactCsp.value">
                  {{ contactCsp.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="column"
            :class="fromQuickview ? 'is-12' : 'is-4'">
            <v-input
              id="profession"
              name="profession"
              @input="c.profession = $event"
              :model="c.profession"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Profession">
              <r-label
                slot="label"
                :is-required="hasCheck"
                :red-check="hasCheck"
                :label="'Profession'"
                :value="c.profession"></r-label>
            </v-input>
          </div>
          <div
            :id="`company-${viewId}`"
            class="column"
            v-if="!['unemployed', 'retirement'].includes(c.csp)"
            :class="fromQuickview ? 'is-12' : 'is-4'">
            <v-input
              id="company"
              name="company"
              @input="c.company = $event"
              :model="c.company"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Société">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Société'"
                :value="c.company"></r-label>
            </v-input>
          </div>
        </div>
      </div>
      <div
        class="is-padding has-background-white"
        v-if="!fromQuickview">
        <div class="columns is-multiline">
          <CustomFieldInput
            v-for="(customField, i) in c.customs_fields"
            :key="i"
            :class="`column ${customField.customfieldlink.custom_field_pk.input_config.size.value || 'is-3'}`"
            :custom-field="customField.customfieldlink.custom_field_pk"
            :value="customField.customfieldlink.value"
            @change="customField.customfieldlink.value = $event" />
        </div>
        <div
          v-if="isAdmin"
          @click="$router.push({name: 'CustomFieldForm'})"
          class="columns is-gapless w100">
          <div
            class="column w100 has-text-centered is-padding is-margin-small is-border is-border--dashed columns is-gapless is-vcentered is-centered has-background-white-bis">
            <div class="column file-label">
              <span class="is-uppercase">Ajouter un champ personnalisé au formulaire&nbsp;</span>
              <b class="is-uppercase is-underline">Cliquer ici</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="contactFormTab === 'SITUATION_FISCALE'">
      <div class="is-padding is-border-bottom">
        <div class="field">
          <r-label
            :is-required="false"
            label="Propriétaire ou locataire"
            :value="c.financial_data.is_owner"></r-label>
          <div class="control">
            <div class="columns is-variable is-2 is-multiline is-vcentered">
              <div class="column is-4">
                <input
                  id="ower_no"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  type="radio"
                  name="nature"
                  :value="false"
                  v-model="c.financial_data.is_owner">
                <label for="ower_no">Locataire</label>
              </div>
              <div class="column is-4">
                <input
                  id="owner_yes"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  type="radio"
                  name="nature"
                  :value="true"
                  v-model="c.financial_data.is_owner">
                <label for="owner_yes">Propriétaire</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="is-padding has-background-light is-border-bottom">
        <div class="columns is-multiline">
          <div class="column is-12">
            <input
              id="invest"
              type="checkbox"
              name="invest"
              v-model="c.financial_data.invest"
              class="switch is-success is-rounded">
            <label
              for="invest"
              class="label"><span>Investissement locatif</span></label>
          </div>
        </div>
      </div>
      <div
        class="is-padding has-background-light"
        id="financials">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div
              v-if="c.financial_data.invest"
              class="columns">
              <div class="column">
                <v-input
                  id="invest_type"
                  name="invest_type"
                  @input="c.financial_data.invest_type = $event"
                  :model="c.financial_data.invest_type"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Nature de l'investissement">
                  <r-label
                    slot="label"
                    :is-required="false"
                    :label="'Nature de l\'investissement'"
                    :value="c.financial_data.invest_type"></r-label>
                </v-input>
              </div>
              <div class="column is-4">
                <v-input
                  id="invest_value"
                  name="invest_value"
                  step="1"
                  input-type="number"
                  :min="0"
                  :three-space="true"
                  @input="c.financial_data.invest_value = $event"
                  :model="c.financial_data.invest_value"
                  :errors-bag="errors"
                  :number="true"
                  data-vv-value-path="val"
                  data-vv-as="Valeur de l'achat"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="false"
                    label="Valeur de l'achat"
                    :value="c.financial_data.invest_value"></r-label>
                  <p
                    class="control"
                    slot="addonRight">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-euro-sign"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
              <div class="column is-3">
                <date-picker
                  label="Date de l'achat"
                  :model="c.financial_data.invest_date"
                  @input="c.financial_data.invest_date = $event"
                  :style-version="2"></date-picker>
              </div>
            </div>
          </div>
          <div
            v-if="displayLoans"
            class="column is-12">
            <div
              class="columns is-multiline"
              v-for="(loan, i) in contactLoans"
              :key="i">
              <div class="column">
                <v-input
                  id="loan_type"
                  name="loan_type"
                  @input="loan.loan_type = $event"
                  :model="loan.loan_type"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Type de prêt">
                  <r-label
                    slot="label"
                    :is-required="false"
                    label="Type de prêt"
                    :value="loan.loan_type"></r-label>
                </v-input>
              </div>
              <div class="column is-3">
                <v-input
                  id="monthly_cost"
                  name="monthly_cost"
                  step=".01"
                  input-type="number"
                  :number="true"
                  :min="0"
                  :three-space="true"
                  @input="loan.monthly_cost = $event"
                  :model="loan.monthly_cost"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Montant (mensuel)"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="false"
                    label="Montant (mensuel)"
                    :value="loan.monthly_cost"></r-label>
                  <p
                    class="control"
                    slot="addonRight">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-euro-sign"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
              <div class="column is-3">
                <date-picker
                  label="Date fin de prêt"
                  :is-required="false"
                  :model="loan.ending_date"
                  @input="loan.ending_date = $event"
                  :style-version="2"></date-picker>
              </div>
              <div class="column is-2">
                <v-input
                  id="loan_rate"
                  name="loan_rate"
                  :step=".01"
                  :max="100"
                  input-type="number"
                  :min="0"
                  @input="loan.loan_rate = $event"
                  :model="loan.loan_rate"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Taux"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="false"
                    label="Taux"
                    :value="loan.loan_rate"></r-label>
                  <p
                    class="control"
                    slot="addonRight">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-percentage"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
              <div class="column is-narrow">
                <r-label
                  :blank-label="true"
                  :is-required="false"
                  :truncate="false"></r-label>
                <a
                  class="button is-danger is-radiusless is-square"
                  @click="contactLoans.splice(i, 1)">
                  <span class="icon"><i class="fas fa-trash"></i></span>
                </a>
              </div>
            </div>
            <div class="">
              <a
                @click="addLoan"
                class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large">
                <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-plus-circle"></i></span>
                <span class="is-transform-none">Ajouter un prêt bancaire</span>
              </a>
            </div>
          </div>
          <div class="column is-3">
            <v-input
              id="income"
              name="income"
              step=".01"
              input-type="number"
              :min="0"
              :three-space="true"
              @input="c.income = $event"
              :model="c.income"
              :errors-bag="errors"
              :number="true"
              data-vv-value-path="val"
              data-vv-as="Revenus déclarés"
              :has-addons="true">
              <r-label
                slot="label"
                label="Revenus déclarés"
                :is-required="false"
                :value="c.income"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              id="land_income"
              name="land_income"
              step=".01"
              input-type="number"
              :min="0"
              :number="true"
              :three-space="true"
              @input="c.financial_data.land_income = $event"
              :model="c.financial_data.land_income"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Revenus foncier"
              :has-addons="true">
              <r-label
                slot="label"
                label="Revenus foncier"
                :is-required="false"
                :value="c.financial_data.land_income"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              id="tax_income"
              name="tax_income"
              step=".01"
              input-type="number"
              :min="0"
              :number="true"
              :three-space="true"
              @input="c.financial_data.tax_income = $event"
              :model="c.financial_data.tax_income"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Montant impôt"
              :has-addons="true">
              <r-label
                slot="label"
                label="Montant impôt"
                :is-required="false"
                :value="c.financial_data.tax_income"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <r-label
              :is-required="false"
              label="Parts fiscales"
              :value="c.financial_data.fiscal_share"></r-label>
            <input
              name="fiscal_share"
              v-model.number="c.financial_data.fiscal_share"
              class="input"
              step="1"
              max="100"
              type="number">
          </div>
          <div class="column is-3">
            <v-input
              id="monthly_outcome"
              name="monthly_outcome"
              step=".01"
              input-type="number"
              :min="0"
              :number="true"
              :three-space="true"
              @input="c.financial_data.monthly_outcome = $event"
              :model="c.financial_data.monthly_outcome"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Charges fixes mensuelle"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="false"
                label="Charges fixes mensuelle"
                :value="c.monthly_outcome"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              id="debt"
              name="debt"
              step=".01"
              input-type="number"
              :min="0"
              :number="true"
              :three-space="true"
              @input="c.financial_data.debt = $event"
              :model="c.financial_data.debt"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Endettement"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="false"
                label="Endettement"
                :value="c.financial_data.debt"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              id="monthly_saving"
              name="monthly_saving"
              step=".01"
              input-type="number"
              :min="0"
              :number="true"
              :three-space="true"
              @input="c.financial_data.monthly_saving = $event"
              :model="c.financial_data.monthly_saving"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Effort d'épargne (mensuel)"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="false"
                label="Effort d'épargne (mensuel)"
                :value="c.financial_data.monthly_saving"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              id="available_capital"
              name="available_capital"
              step=".01"
              input-type="number"
              :min="0"
              :three-space="true"
              @input="c.financial_data.available_capital = $event"
              :model="c.financial_data.available_capital"
              :errors-bag="errors"
              :number="true"
              data-vv-value-path="val"
              data-vv-as="Capital disponible"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="false"
                label="Capital disponible"
                :value="c.financial_data.available_capital"></r-label>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
      </div>
    </div>
    <div v-show="contactFormTab === 'DOCS'">
      <div class="has-background-light is-padding">
        <div class="title is-5">
          <b class="is-uppercase">Documents</b>
          <!-- <span class="is-padding-left-xsmall" v-helper.bottom="'Zkzotf83I4r2ecwDnBy7Y'">
            <i class="fal fa-info-circle"></i>
          </span> -->
        </div>
        <tabs
          :links="documentsTabs"
          :level="1"
          :current-tab="documentsTab"
          classes="has-background-light"
          mode="emitter"
          @changeView="documentsTab = $event"
          :is-fullwidth="true"></tabs>
        <div class="is-padding-top">
          <upload-file
            :multiple="true"
            :custom-id="'documents'"
            :placeholder="'Sélectionner document(s)'"
            :source-documents="documentsToDisplay"
            :has-destination="true"
            :destinations-list="contactDocumentsDestinations"
            :hide-upload="documentsTab !== 'DOCUMENTS'"
            @upload="uploadDocument({ files: $event })"
            @deleteDocument="deleteDocument({ document: $event })"></upload-file>
        </div>
      </div>
    </div>
    <submit-sticky-buttons
      v-if="!fromQuickview"
      @submit="submit"
      @check="check"
      :loading="submitLoading"
      :alertdoublon="alertDoublon"
      :show-user-change-modal="showUserChangeModal"
      button-id="contactForm"></submit-sticky-buttons>
  </form>
</template>

<script>
// import { DateFormatter } from '@amcharts/amcharts4/core'
import { mapGetters, mapState } from 'vuex'
import ContactMixin from './ContactMixin'
import CustomFields from '@/mixins/CustomFieldsMixin'

export default {
  name: 'ContactForm',
  components: {
    CustomFieldInput: () => import('@/components/utils/form/CustomFieldInput')
  },
  mixins: [ContactMixin, CustomFields],
  props: {
    paramsQuickview: null,
    newContact: Boolean,
    alertdoubloncheck: Object
  },
  data () {
    return {
      contactFormLinks: [
        { link: 'INFOS', label: 'Fiche contact' },
        { link: 'COMMENTS', label: 'Commentaire sur le contact' }
      ],
      users: null,
      origin: null,
      origins: [],
      programs: [],
      showMoreQuickview: false,
      hasCheck: false,
      viewId: null,
      contactFormTab: 'FICHE_CONTACT',
      documentsTab: 'DOCUMENTS',
      childrenNumber: [],
      checkDoublon: false,
      alertDoublon: false,
      programsFilter: [],
      originalContact: null,
      showUserChangeModal: false
    }
  },
  computed: {
    ...mapState(['quickview', 'claimCreateContact', 'currentUser']),
    ...mapGetters(['originGroups', 'activeOriginGroups', 'canUseBuyerSpace']),
    canEditOrigin () {
      return !this.newContact && this.contact && this.contact.account && this.contact.account.pk === this.currentUser.account.pk && !this.fromQuickview
    },
    canEditProgram () {
      if (this.newContact && !this.fromQuickview) {
        return true
      } else {
        return this.contact && this.contact.account && this.contact.account.pk === this.currentUser.account.pk && !this.fromQuickview
      }
    },
    displayLoans () {
      return this.c.financial_data.invest || this.c.financial_data.is_owner
    },
    isReplaceBuyer () {
      return !!(this.paramsQuickview && this.paramsQuickview.replaceBuyer)
    },
    contactFormTabsLinks () {
      let tabs = [
        { link: 'FICHE_CONTACT', label: 'Fiche du contact' }
      ]
      if (!this.fromQuickview) {
        tabs.push(
          { link: 'SITUATION_FISCALE', label: 'Situation fiscale' },
          { link: 'DOCS', label: 'Documents', disable: this.newContact }
        )
      }
      if (this.fromQuickview && !(this.paramsQuickview && this.paramsQuickview.fromBuyerEdit)) {
        tabs.push(
          { link: 'CONTACT_SELECTION', label: 'Sélectionner un contact' }
        )
      }
      return tabs
    },
    allDocumentList () {
      if (this.c.documents) {
        return this.c.documents
      } else {
        return []
      }
    },
    reservationDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('reservation')
      })
    },
    buyerSpaceDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('buyer_space')
      })
    },
    documentsTabs () {
      const docs = [
        {
          label: `TOUS LES DOCUMENTS (${this.allDocumentList.length || 0})`,
          link: 'DOCUMENTS',
          class: 'is-size-6'
        },
        {
          label: `DOSSIER DE RÉSERVATION (Annexé au contrat) (${this.reservationDocumentList.length || 0})`,
          link: 'RESERVATION',
          class: 'is-size-6'
        }
      ]
      return docs
    },
    contactDocumentsDestinations () {
      const destinations = {
        reservation: { label: 'Dossier de réservation', key: 'reservation', enabled: true },
        buyer_space: { label: 'Espace acquéreur', key: 'buyer_space', enabled: false }
      }
      return Object.values(destinations)
    },
    documentsToDisplay () {
      if (this.documentsTab === 'RESERVATION') return this.reservationDocumentList
      else if (this.documentsTab === 'ESPACE_ACQUEREUR') return this.buyerSpaceDocumentList
      else return this.allDocumentList
    },
    isMarriedOrPacsed () {
      return ['married', 'pacs'].includes(this.c.family_situation)
    },
    isDivorced () {
      return this.c.family_situation === 'divorced'
    },
    isDivorcedDate () {
      if (this.c.divorce_date !== null) {
        return this.c.divorce_date
      } else return null
    }
  },
  watch: {
    'c.wedding_notary_data' (v) {
      if (!v) this.c.wedding_notary_data = { name: null, city: null }
    },
    'contactUser' (v) {
      this.sendData()
      this.ListenDataToRedirect()
    },
    'c.address' (v) {
      this.sendData()
      this.ListenDataToRedirect()
    },
    'c.last_name' (v) {
      this.sendData()
      this.ListenDataToRedirect()
    },
    'c.first_name' (v) {
      this.sendData()
      this.ListenDataToRedirect()
    },
    'c.email' (v) {
      this.sendData()
      this.ListenDataToRedirect()
    },
    'c.children' (v) {
      if (v === 0) {
        this.c.children_date = []
      } else {
        if (this.c.children_date.length > v) {
          this.c.children_date = this.c.children_date.slice(0, v)
        } else if (this.c.children_date.length < v) {
          for (let i = this.c.children_date.length; i < v; i++) {
            this.c.children_date.push(null)
          }
        }
      }
      this.childrenNumber = []
      for (let i = v; i > 0; i--) {
        this.childrenNumber.push(i)
      }
    },
    quickview ({ mode, params, results }) {
      if (this.fromQuickview) return
      if (results && mode === 'CONTACT_SELECTION') {
        if (results.entities.length) {
          this.addContact(results.entities[0])
        }
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      }
      if (results && mode === 'CONTACT_CREATE' && params.spouseMode) {
        if (this.contactView === 'ContactCreate' || this.contactView === 'ContactEdit') {
          this.spouseMode = params.spouseMode
          this.createContact(results.contact)
        }
      }
    },
    'c.financial_data.is_owner' (v) {
      if (v && (!this.contactLoans || !this.contactLoans.length)) {
        this.addLoan()
      }
    },
    sourceContact () {
      this.initView()
      this.contactSpouse = null
    }
  },
  async created () {
    await this.get()
    await this.getSellers()
    this.getOrigins()
    await this.getPrograms()
    this.c.customs_fields = this.sortCustomFields(this.c.customs_fields)
    if ('check' in this.$route.query || this.isReplaceBuyer) {
      this.hasCheck = true
    }
    if (this.$route.query.seller) {
      let user = this.users.filter(x => x.pk === this.$route.query.seller)
      this.contactUser = Object.assign({}, user[0])
    }
    this.contactOrigin = this.contact.origin
    if (!this.c.children_date) this.c.children_date = []
    if (!this.c.wedding_notary_data) this.c.wedding_notary_data = { name: null, city: null }
    this.originalContact = this.c
  },
  methods: {
    createSpouseContact () {
      this.$router.push({
        name: 'ContactCreate',
        query: {
          spouseMode: true,
          parentContactId: this.c.pk,
          returnTo: 'ContactEdit'
        }
      })
    },
    async addContact (contact) {
      let completeContact = await this.returnContact(contact.pk)
      this.contactSpouse = completeContact
      this.c.spouse = completeContact
      this.spouseMode = true

      if (this.c.pk) {
        if (this.c.children || this.c.children_date) {
          await this.$api.patch(this.$resources.CONTACT, this.c.pk, {
            children: this.c.children,
            children_date: this.c.children_date
          })
        }
        await this.$api.patch(this.$resources.CONTACT, this.c.pk, { spouse: completeContact.pk })
        await this.$api.patch(this.$resources.CONTACT, completeContact.pk, { spouse: this.c.pk })

        const syncResult = await this.syncChildrenWithSpouse(this.c.pk, completeContact.pk, true)

        if (syncResult) {
          this.c.children = syncResult.contactChildren
          this.c.children_date = syncResult.contactChildrenDates

          this.contactSpouse.children = syncResult.spouseChildren
          this.contactSpouse.children_date = syncResult.spouseChildrenDates
        }
      }

      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    async returnContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    originName (origin) {
      if (origin.parent_name) {
        return origin.parent_name + ' - ' + origin.name
      } else {
        return origin.name
      }
    },
    sendData () {
      this.$emit('send-data', true)
    },
    programName (program) {
      return program.name
    },
    openSpouseEdit (spouse) {
      this.$swal({
        title: 'Changement de fiche contact en cours d\'édition',
        text: 'Vous êtes sur le point de changer de fiche contact. Souhaitez-vous enregistrer les modifications avant de quitter la fiche de ce contact ?',
        confirmButtonText: 'Enregistrer',
        focusConfirm: false
      }).then(result => {
        if (result && result.value) {
          this.$emit('submit', this.c, spouse.pk)
        } else if (result && result.dismiss) {
          this.$router.push({ name: 'ContactEdit', params: { id: this.contactSpouse.pk } })
        }
      })
    },
    submitQuickview () {
      this.c.origin = this.contactOrigin
      if (this.isReplaceBuyer) {
        if (this.c.address) {
          if (this.c.address.city === '' || this.c.address.line1 === '' || this.c.address.country === '' || this.c.address.zip_code === '') this.c.address = null
        }
        if (this.c.first_name === '') this.c.first_name = null
        if (this.c.last_name === '') this.c.last_name = null
        if (this.c.phone === '') this.c.phone = null
        if (this.c.email === '') this.c.email = null
        if (this.c.wedding_place === '') this.c.wedding_place = null
        if (!this.c.address || !this.c.first_name || !this.c.last_name || !this.c.phone || !this.c.email || !this.c.birthday ||
          !this.c.birthplace || !this.c.nationality || !this.c.family_situation || !this.c.profession) {
          return this.$toasted.global.danger('Information(s) obligatoire(s) manquante')
        }
        if (['married', 'pacs'].includes(this.c.family_situation) && (!this.c.matrimonial_status || !this.c.wedding_place || !this.c.wedding_date)) {
          return this.$toasted.global.danger('Information(s) obligatoire(s) manquante')
        }
      }
      const contact = this.isReplaceBuyer ? this.beforeSubmit(this.c) : this.c
      if (this.isReplaceBuyer) {
        // beforeSubmit remplace spouse par contactSpouse, jamais initialisé en quickview :
        // on conserve le conjoint de la fiche pour ne pas le délier au PUT
        contact.spouse = this.c.spouse && this.c.spouse.pk ? this.c.spouse.pk : this.c.spouse
      }
      this.$emit('submitQuickview', { contact })
    },
    async askUserRef (contacts) {
      let value = await this.$swal({
        title: `Attribution contact partagé`,
        text: `Attention vous allez perdre le partage si le contact n’est pas attribué à un utilisateur`,
        confirmButtonText: 'Continuer',
        focusConfirm: false
      })
      return value
    },
    async check () {
      const formIsValid = await this.$validator.validateAll()
      if (!formIsValid) return
      let contact = await this.beforeSubmit(this.c)
      let payload = {}
      if (contact.user) {
        payload = {
          contact: this.$cleanPayload(contact),
          user: contact.user.pk
        }
      } else {
        payload = {
          contact: this.$cleanPayload(contact)
        }
      }
      const originalUserId = (this.originalContact && this.originalContact.user && this.originalContact.user.pk) || null
      const newUserId = (this.contactUser && this.contactUser.pk) || null
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        this.checkDoublon = data
        this.alertDoublon = true
      }
      if (originalUserId !== newUserId) {
        this.showUserChangeModal = true
      }
      if (this.alertDoublon === false && this.showUserChangeModal === false) {
        this.submit()
      }
    },
    async submit () {
      const financialVariables = [
        { variable: this.c.financial_data.land_income, label: 'Revenus foncier' },
        { variable: this.c.income, label: 'Revenus déclarés' },
        { variable: this.c.financial_data.tax_income, label: 'Montant impôt' },
        { variable: this.c.financial_data.fiscal_share, label: 'Parts fiscales' },
        { variable: this.c.financial_data.monthly_outcome, label: 'Charges fixes mensuelle' },
        { variable: this.c.financial_data.debt, label: 'Endettement' },
        { variable: this.c.financial_data.monthly_saving, label: 'Effort d‘épargne (mensuel)' },
        { variable: this.c.financial_data.available_capital, label: 'Capital disponible' }
      ]
      for (const { variable, label } of financialVariables) {
        if (variable !== null && variable !== undefined && !/^(\d*\.\d{1,2}|\d+)$/.test(variable)) {
          this.$toasted.global.danger(`Le ${label} ne peut pas avoir plus de deux chiffres après la virgule.`)
          return
        }
      }
      if (this.contactUser === null && this.c.shared && this.contact.account.pk !== this.currentUser.account.pk) {
        let value = await this.askUserRef()
        if (value.value) {
          let contact = await this.beforeSubmit(this.c)
          this.$emit('submit', contact)
        }
      } else {
        let contact = await this.beforeSubmit(this.c)
        this.$emit('submit', contact)
      }
    },
    updateAddress (address) {
      this.$set(this.c, 'address', address)
    },
    async get () {
      try {
        const { data } = await this.$api.get(this.$resources.USER)
        this.users = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async getOrigins () {
      try {
        const { data } = await this.$api.get(this.$resources.ORIGIN, { sort: 'name:asc' })
        this.origins = data.items
      } catch (e) {
        console.log(e)
      }
    },
    async getPrograms () {
      try {
        const { data } = await this.$api.get(this.$resources.PROGRAM, { sort: 'name:asc' })
        this.programs = data.items
        // for(let prog of this.programs) {
        //   console.log(prog.name);
        // }
      } catch (e) {
        console.log(e)
      }
    },
    async getPrincipalPrograms () {
      try {
        const { data } = await this.$api.get(this.$resources.PROGRAM, { sort: 'name:asc' })
        this.programs = data.items
        // for(let prog of this.programs) {
        //   console.log(prog.name);
        // }
      } catch (e) {
        console.log(e)
      }
    },
    async getOrigin () {
      const { data } = await this.$api.getOne(this.$resources.ORIGIN, this.contact.origin)
      this.origin = data
    },
    async getSellers (query) {
      let params = {
        searchable_name: query
      }
      try {
        const { data } = await this.$api.get(this.$resources.USER, params)
        this.users = data.items
      } catch (e) {
        console.log(e)
      }
    },
    addLoan () {
      if (!this.contactLoans || !Array.isArray(this.contactLoans)) this.contactLoans = []
      this.contactLoans.push({ loan_type: null, monthly_cost: null, ending_date: null, loan_rate: null })
    },
    ListenDataToRedirect () {
      if (this.paramsQuickview && this.paramsQuickview.alert === true) {
        let alert = false
        this.$store.commit('setQuickview', {
          mode: 'CONTACT_CREATE',
          params: { searchKeys: 'CONTACT', contact: this.c, alert: alert }
        })
      } else {
        this.checkDoublon = null
        this.alertDoublon = false
      }
    },
    async getProgramsByName (query) {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM, { searchable_name: query })
        this.programsFilter = data.items
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la récupération des programmes.')
      }
    },
    handleTabChange (tab) {
      if (tab === 'CONTACT_SELECTION') {
        let params = {
          facets: {
            CONTACT: [
              [`pk:-${this.contactPk}`],
              ['spouse:null']
            ]
          },
          selectType: 'simple',
          mode: 'store',
          index: this.paramsQuickview.index,
          note: 'replaceBuyer',
          previousMode: 'CONTACT_CREATE',
          previousParams: { ...this.paramsQuickview }
        }
        this.openContactSelectionQuickview({ params })
        return
      }
      this.contactFormTab = tab
    }
  }
}
</script>

<style scoped>
::v-deep .tabs.is-fullwidth li {
  flex-basis: 0;
}
</style>
